import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction;

export const setNavigateFunction = (_navigator: NavigateFunction) => {
    navigate = _navigator;
};

export const router = (_path: string) => {
    navigate(_path);
};

export default () => navigate;
